module.exports = __webpack_public_path__ + "static/media/sumavigroup ui-10.81b81ce2.svg";